import { PageId } from 'constants/pages'

export const enum PageIdIntlHlwn70 {
  OFFER = PageId.OFFER_INTL_HLWN70,
  SPECIAL_DISCOUNT = PageId.SPECIAL_DISCOUNT_INTL_HLWN70,
  CANCEL_OFFER = PageId.CANCEL_OFFER_INTL_HLWN70,
  PAYMENT = PageId.PAYMENT_INTL_HLWN70,
  CHECKOUT = PageId.CHECKOUT_INTL_HLWN70,
  UPSELL = PageId.UPSELL_INTL_HLWN70,
  REGISTRATION = PageId.REGISTRATION_INTL_HLWN70,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_HLWN70,
  CERTIFICATE = PageId.CERTIFICATE_INTL_HLWN70,
  LEARNWORLDS_REDIRECT = PageId.LEARNWORLDS_REDIRECT_INTL_HLWN70,
  REPORT = PageId.REPORT_INTL_HLWN70,
}
